import ajax from './ajax'
import clientApi from './clientApi'
import consts from './consts'
import { Dialog } from 'vant';
const baseUrl = 'https://vm.moneyds.cn/';
// const baseUrl ='/api';
export default {
    baseUrl,
    checkProxyFunc(){
        return new Promise((resolve, reject)=>{
            // resolve()
            ajax({
                url: consts.clientBaseurl+'/CheckIphoneProxy',
                dataType: 'json',
                success: function(data) {
                    if (data.data == 1) {
                        Dialog.alert({message: '网络环境异常,请关闭代理'}).then(()=>{
                            document.location.href = "LongFlower://";
                        });
                        reject();
                    }else {
                        resolve();
                    }
                }
            }); 
        })
    },
    checkClientLogin() {
        return new Promise((resolve, reject) => {
            // resolve()
            clientApi.isClientLogin()
            .then((res)=>{
                if (res.status == 1) {
                    if(res.data.newlogin != true){
                        //助手连接失败
                        reject()          
                    }else {
                        //成功      
                        this.checkProxyFunc().then((res)=>{
                            resolve();
                        }).catch((err)=>{
                            reject(err);
                        })
                    }
                }else {
                    //助手连接失败
                    reject()
                }
            })
            .catch((err)=>{
                //助手连接失败
                reject()
            }) 
        })
    }
}
